import React from 'react';
import { Property } from '../../../types';
import { formatCurrency } from '../../../utils/formatters';
import { MapPinIcon } from '../../Icons';
import { HabiPurchaseRightBadge } from './HabiPurchaseRightBadge';
import { NegotiablePriceBadge } from './NegotiablePriceBadge';

export const SharedPropertyHeader: React.FC<{ property: Property }> = ({ property }) => {
    return (
        <header className="space-y-6">
            <div className="bg-[#005A9E] p-8 rounded-2xl text-white shadow-xl animate-fade-in-up">
                <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
                    <div>
                        <div className="flex items-center gap-2.5 mb-2 flex-wrap">
                            <span className="text-xs font-black uppercase tracking-[0.2em] opacity-80 block">Valor de Inversión</span>
                            <NegotiablePriceBadge variant="header" />
                        </div>
                        <h2 className="text-4xl sm:text-5xl font-black tracking-tighter leading-none">
                            {formatCurrency(property.precio_venta)}
                        </h2>
                    </div>
                    {property.valor_administracion > 0 && (
                        <div className="sm:text-right border-l-4 sm:border-l-0 sm:border-r-4 border-white/20 pl-4 sm:pl-0 sm:pr-4">
                            <span className="text-[10px] font-black uppercase tracking-widest opacity-80 block mb-1">Administración</span>
                            <p className="text-xl font-bold">{formatCurrency(property.valor_administracion)}</p>
                        </div>
                    )}
                </div>
            </div>

            <HabiPurchaseRightBadge property={property} />

            <div className="px-2">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="bg-sky-100 text-sky-700 px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-widest">
                        {property.tipoinmueble}
                    </span>
                    <span className="text-gray-400 text-xs font-bold font-mono">Cód: {property.codigo}</span>
                </div>
                <h1 className="text-3xl font-black text-gray-900 uppercase tracking-tighter leading-tight">
                    {property.neighborhoodName || property.ciudad}
                </h1>
                <p className="flex items-center text-gray-500 mt-2 font-medium">
                    <MapPinIcon className="w-5 h-5 mr-2 text-sky-600" />
                    {property.direccion} • {property.localidad}, {property.ciudad}
                </p>
            </div>
        </header>
    );
};